import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/roundtables/${id}/summary-data`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/getSummaryTableData.js